export const partnersCodeGroupActionButtons = (
  status,
  handleActionButtons,
  partnerCodeGroupData
) => {
  const actionButtons = [
    {
      icon: "visibility",
      onClick: () => handleActionButtons("view", partnerCodeGroupData),
    },
    {
      icon: "content_copy",
      disabled: partnerCodeGroupData?.processingStatus === "IMPORTING",
      onClick: () => handleActionButtons("copy", partnerCodeGroupData),
    },
  ];

  const deletableStatuses = ["INACTIVE", "EXPIRED"];
  const editableStatuses = ["INACTIVE", "ACTIVE"];

  editableStatuses.includes(status) &&
    actionButtons.push({
      icon: "edit",
      disabled: partnerCodeGroupData?.processingStatus === "IMPORTING",
      onClick: () => handleActionButtons("edit", partnerCodeGroupData),
    });

  deletableStatuses.includes(status) &&
    actionButtons.push({
      icon: "delete",
      disabled: partnerCodeGroupData?.processingStatus === "IMPORTING",
      onClick: () => handleActionButtons("delete", partnerCodeGroupData),
    });
  return actionButtons;
};
